<template>
  <div class="flex h-full items-center">
    <GfrMenuNav>
      <GfrMenuList>
        <GfrMenuItem
          v-for="(item, index) in menuList"
          :key="index"
          :as-trigger="hasChildren(item)"
          class="uppercase ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
        >
          <GfrMenuLink
            :to="formatRoutePath(item.link)"
            :target="isNewTabOpen(item) ? '_blank' : '_self'"
            has-active-line
          >
            {{ item.name }}
            <IconsOutArrow v-if="isOutsideLink(item)" class="ml-2 mt-0.5 h-3.5 w-3.5 rtl:mt-0 rtl:-rotate-90" />
            <IconsArrow
              v-else-if="hasChildren(item)"
              class="ltr:ml-2 rtl:mr-2 mt-0.5 h-3.5 w-3.5 transition-transform duration-300 group-data-[state=open]:rotate-180"
            />
          </GfrMenuLink>
          <GfrMenuView v-if="hasChildren(item)">
            <GfrMenuContent :level="2">
              <GfrMenuList class="gfr-menu-content-list capitalize">
                <GfrMenuItem v-for="(subitem, i) in item.children" :key="i" class="gfr-menu-content-item">
                  <GfrMenuLink
                    class="gfr-menu-content-link w-full h-full text-white"
                    :to="formatRoutePath(subitem.link)"
                    :target="isNewTabOpen(subitem) ? '_blank' : '_self'"
                    @click="socialMediaShare(subitem, $event)"
                  >
                    <img :src="subitem.icon" class="ltr:mr-2 rtl:ml-2 mt-0.5 h-6.5 w-6.5" />
                    {{ subitem.name }}
                    <!-- <IconsOutArrow v-if="isOutsideLink(subitem)" class="ml-1 mt-0.5 h-3.5 w-3.5" /> -->
                  </GfrMenuLink>
                  <!-- <GfrMenuList v-if="hasChildren(subitem)" class="gfr-menu-content-list">
                    <GfrMenuItem v-for="(grandItem, j) in subitem.children" :key="j" class="gfr-menu-content-item">
                      <GfrMenuLink
                        class="gfr-menu-content-linktext-white"
                        :to="formatRoutePath(grandItem.link)"
                        :target="isNewTabOpen(grandItem) ? '_blank' : '_self'"
                      >
                        {{ grandItem.name }}
                        <IconsOutArrow v-if="isOutsideLink(grandItem)" class="ml-1 mt-0.5 h-3.5 w-3.5" />
                      </GfrMenuLink>
                    </GfrMenuItem>
                  </GfrMenuList> -->
                </GfrMenuItem>
              </GfrMenuList>
            </GfrMenuContent>
          </GfrMenuView>
        </GfrMenuItem>
      </GfrMenuList>
    </GfrMenuNav>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import type { ConfigApiMenu } from '@/server/types'
const store = useStore()
const { config } = storeToRefs(store)
const { formatTransify } = store
const socialMediaMenu = computed(() => {
  if (!config.value.config.social_media) {
    return []
  }
  const menu: ConfigApiMenu[] = config.value.config.social_media.map((item, index) => {
    return {
      id: index + 1,
      icon: item.icon,
      name: item.name,
      link: item.url,
      deeplink: item.deeplink,
      is_new_tab: 1,
      is_outside_website: 0
    }
  })
  return menu
})
const menuList = computed(() => {
  const clMenu: ConfigApiMenu[] = [
    {
      id: 0,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_SQUARE'),
      link: '/{lang}/',
      is_new_tab: 0,
      is_outside_website: 0
    },
    {
      id: 1,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_TUTORIAL'),
      link: '/{lang}/tutorial/',
      is_new_tab: 0,
      is_outside_website: 0
    },
    {
      id: 2,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_WIKI'),
      link: '/{lang}/wiki/',
      is_new_tab: 0,
      is_outside_website: 0
    },
    {
      id: 3,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_UPDATED'),
      link: '/{lang}/updated/',
      is_new_tab: 0,
      is_outside_website: 0
    },
    {
      id: 4,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_COMMUNITY'),
      link: '/{lang}/community/',
      is_new_tab: 0,
      is_outside_website: 0
    }
  ]
  socialMediaMenu.value.length > 0 &&
    clMenu.push({
      id: 5,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_JOINUS'),
      link: '',
      is_new_tab: 0,
      is_outside_website: 0,
      children: socialMediaMenu.value
    })
  return clMenu
})
const route = useRoute()
function formatRoutePath(link: string) {
  return link.replace('{lang}', route.params.lang as string)
}
function hasChildren(item: ConfigApiMenu) {
  return !!item.children && item.children.length > 0
}
function isOutsideLink(item: ConfigApiMenu) {
  return item.is_outside_website === 1
}
function isNewTabOpen(item: ConfigApiMenu) {
  return item.is_new_tab === 1
}
function socialMediaShare(item: ConfigApiMenu, event: MouseEvent) {
  const { goToSocialMedia, inGame } = useGame()
  if (inGame()) {
    event.preventDefault()
    goToSocialMedia(item.name as SocialMediaName, item.deeplink || '', item.link || '')
  }
}
</script>
